import type { ReactNode } from 'react'

/**
 * Shared chrome for legal pages (Terms, Privacy, Acceptable Use): a title,
 * an effective date, and a typography-plugin prose container for the body.
 * The body content lives in the CMS (`cms_documents`, kind 'legal'); the
 * route passes the rendered markdown in as `children` along with the
 * title/effectiveDate from the same row.
 */
export default function LegalLayout({
  title,
  effectiveDate,
  children,
}: {
  title: string
  effectiveDate: string | null
  children: ReactNode
}) {
  return (
    <main className="mx-auto w-full max-w-3xl px-4 py-16">
      <h1 className="text-4xl font-bold tracking-tight text-balance">
        {title}
      </h1>
      {effectiveDate ? (
        <p className="mt-2 text-sm text-muted-foreground">
          Effective {effectiveDate}
        </p>
      ) : null}
      <div className="prose prose-neutral mt-8 max-w-none dark:prose-invert">
        {children}
      </div>
    </main>
  )
}
